if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let productsToAdd = []

        const subPlans =  this.form.querySelectorAll('.subscription-plan');
        let bundleOffers = this.form.querySelectorAll('.bundle-creator__bundle-offers__bundle-offer');
        
        subPlans.forEach(plan => {
          const planRadio = plan.querySelector("input[name=selling_plan]");
          
          if (planRadio.checked) {
            productsToAdd.push({
              variant: planRadio.getAttribute("data-variant-id"),
              selling_plan: planRadio.value
            })
          }
          
        })

          bundleOffers.forEach((offer, index) => {

            const attributeObject = {};
            [...offer.attributes].forEach(attribute => {
              attributeObject[attribute.name] = attribute.value;
            });
            // console.log(attributeObject);

            if (offer.querySelector('input[type=checkbox]').checked) {
              productsToAdd.push({
                variant: attributeObject["data-selected-variant-id"],
                selling_plan: attributeObject["data-selected-selling-plan-id"]
              })
            }
            

          })

        // console.log(productsToAdd)
        

        const formData = new FormData(this.form);

          formData.delete('id')
          formData.delete('selling_plan')


          productsToAdd.forEach((product, index) => {
          formData.append(`items[${index}][id]`, product.variant)
          formData.append(`items[${index}][selling_plan]`, product.selling_plan)
          })
        
 
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        // for (var pair of formData.entries()) {
        //     console.log(pair[0]+ ', ' + pair[1]); 
        // }
        // console.log(this)

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


        // let offerTwo = document.querySelector('#offer2');
        // let addOnOne = document.querySelector('#add-on-1');
        // let addOnTwo = document.querySelector('#add-on-2');

        // if (addOnTwo) {
        //   addOnOne.addEventListener('change', e => {
        //     console.log(123)
        //     if (e.target.checked) {
        //       offerTwo.style.display = "block"
        //     }
        //   })
        // }